export const getCardContainerStyles = () => ({
  container: ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
    boxSizing: 'border-box',
  }),
  header: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 50,
    borderBottom: '1px solid #EDEBE9',
    padding: [14, 16],
  },
  title: {
    fontSize: 16,
    lineHeight: '22px',
    color: '#323130',
    fontWeight: 600,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    padding: 16,
  },
  footer: {
    paddingTop: 16,
  },
});
